import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  tieu_de: undefined, // required - Tiêu đề (plain-text)
  gioi_thieu: undefined, // optional - Nội dung giới thiệu ngắn gọn (plain-text)
  // optional - Thông tin dòng họ gửi đánh giá
  dong_ho: {
    dong_ho_id: undefined, // optional, ref: dong_ho - Đánh giá từ dòng họ
    ten: undefined, // optional - Tên hiển thị
    dia_chi: undefined, // optional - Địa chỉ hiển thị
  },
  ten_nguoi_danh_gia: undefined, // optional - Tên người đánh giá (Nếu có)
  anh_id: undefined, // optional, ref: mushroom_file - Ảnh nền
  video_id: undefined, // optional, ref: mushroom_file - Video nền
  duong_dan: undefined, // optional - Đường dẫn chứa bài viết giới thiệu chi tiết (nếu có)
  thu_tu: undefined, // required - Thứ tự hiển thị
  // required - Cấu hình thời điểm hiệu lực
  hien_thi: {
    an: undefined, // required - Cho biết có ẩn hay không
    hieu_luc_tu: undefined, // optional - Thời điểm bắt đầu có hiệu lực
    hieu_luc_den: undefined, // optional - Thời điểm hết hiệu lực
    dieu_kien: [], // required, array items: required, enum(all, android, ios, iphone, ipad, pc, windows, macos) - Danh sách điều kiện hiển thị
  },
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thu_tu",
  defaultSort: ["thu_tu", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      ten: "",
      cong_khai: "",
    },
    valid: {
      tieu_de: [],
      thu_tu: []
    },
    operator: {
      tieu_de: ":regex_i:",
      "dong_ho.ten": ":regex_i:",
    },
  },
};

export default model;
